import { Controller } from "react-hook-form/dist/index.ie11";
import ErrorMessage from "./ErrorMessage";
import Label from "./Label";
import { useFormContext } from "./FormProvider";
import { v4 as uuidv4 } from "uuid";

const UUID = uuidv4();

import PropTypes from "prop-types";
StandardInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  rules: PropTypes.object,
  defaultValue: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  checked: PropTypes.bool,
  inputChange: PropTypes.func,
  hidden: PropTypes.bool,
};

StandardInput.defaultProps = {
  name: "input",
  label: "Label",
  defaultValue: "",
  className: "",
  value: "",
  inputChange: () => null,
  hidden: false,
};

export default function StandardInput({
  name,
  label,
  rules,
  className,
  disabled,
  checked,
  inputChange,
  type = "checkbox", // Default to checkbox
  value,
}) {
  const { control, errors } = useFormContext();
  const id = `${name}__${UUID}__${value}`; // Include value to keep IDs unique

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={checked}
      render={({ onChange, value: fieldValue = "" }) => (
        <div className={"field field-checkbox" + className}>
          <div className="control">
            <input
              id={id}
              disabled={disabled}
              onChange={(e) => {
                const val = type === "checkbox" ? e.target.checked : e.target.value;
                onChange(val);
                inputChange && inputChange(e);
              }}
              type={type}
              name={name}
              value={value}
              checked={type === "radio" ? fieldValue === value : fieldValue}
              className={type}
            />
            {type === "checkbox" && <div className="checkbox-toggle"><div /></div>}
          </div>

          <Label value={label} htmlFor={id} />
          <ErrorMessage error={errors[name]} />
        </div>
      )}
    />
  );
}
